import { Fields as MerchantFields } from 'models/Merchant'
import { matchesAnyProvider } from 'utilities/posProviders'

// 'toast' is a `Pos::Provider#value` as served by the merchant API in
// `merchant.all_redemption_providers[].value` (nucleus `pos_providers` table).
// There is no backend flag for "has Toast" — this is a frontend product
// decision, so this set is the source of truth and must be updated by hand if
// the Toast provider value ever changes server-side.
const TOAST_POS_PROVIDERS = new Set(['toast'])

/**
 * True when ANY of the merchant's redemption providers is Toast. A merchant
 * with only some locations on Toast still needs the Toast-specific note,
 * since at least one location is affected.
 */
export const hasToastLocation = (
  merchant: MerchantFields | null | undefined
): boolean => matchesAnyProvider(merchant, TOAST_POS_PROVIDERS)
